import type { TField } from "@shared/types/form";
import { useIntl } from "react-intl";
import { TextField } from "./text-field";

export function EmailField({ label, ...props }: TField) {
	const intl = useIntl();
	return (
		<TextField
			label={label}
			type="email"
			placeholder={intl.formatMessage({
				id: "form.field.email.placeholder",
				defaultMessage: "Enter email",
			})}
			{...props}
		/>
	);
}
